import {
    Button,
    Grid,
    Paper,
    TextField,
    FormHelperText,
    Typography
} from '@mui/material'

import qs from 'qs'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { ROUTELOGIN, ROUTEHOME } from '../../routes'
import { AppState } from 'src/store'
import {
    addSnackbar,
    changePage
} from '../../actions'
import { Error } from 'src/domains/explorer/types';
import Header from '../components/Header';
import { changePageTitle } from '../../actions';
import { httpPost, GenericHttpResponse } from 'src/api/generic';

const renderErrors = (errors: { [key: string]: Error[] }, name: string) => {
    const errKey = '/' + name;
    return errors[errKey] && errors[errKey].map((err, index) => (
        <FormHelperText
            id={'field-error-' + name}
            key={index}
            sx={{ color: theme => theme.palette.error.main }}
        >
            {err.message}
        </FormHelperText>
    ))
};

const renderConfirmMessage = () => {
    return <Grid
        container
        direction='column'
        justifyContent='space-around'
        spacing={1}
    >
        <Typography>{'Your password has been successfully changed.'}</Typography>
    </Grid>
};

const ChangePassword: React.FC = () => {
    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState(''); // old pass
    const [password, setPassword] = useState(''); // pass
    const [confirmPassword, setConfirmPassword] = useState(''); // pass
    const [errors, setErrors] = useState<{ [key: string]: Error[] }>({});
    const [changed, setChanged] = useState<boolean>(false);
    const location = useLocation();

    const apiEndpoint = useSelector((state: AppState) => state.global.options.baseUrl);

    useEffect(() => {
        dispatch(changePageTitle('Change Password'));
    }, []);

    useEffect(() => {
        setOldPassword('');
        setPassword('');
        setConfirmPassword('');
        setErrors({});
        setChanged(false);
    }, [location.key]);

    const change = async () => {
        let endpoint = apiEndpoint + '/changePassword';

        let body = {
            oldPassword,
            password,
            confirmPassword,
        };

        let options: RequestInit = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: qs.stringify(body),
        };

        
        try {
            const response = await httpPost('/changePassword', {}, {}, body);
            if (response.status === 200) {
                dispatch(addSnackbar('Password changed!', 'changePasswordSuccess', {}));
                setChanged(true);
            } else {
                dispatch(addSnackbar('Change password error!', 'changePasswordError', {}));
                let json = await response.json();
                if (json != null) {
                    setErrors(json);
                }
            }
        } catch (err) {
            dispatch(addSnackbar('Change password error!', 'changePasswordError', {}));
        }

    }

    const cancel = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(ROUTEHOME));
    }

    return (<>
        <Header />
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', backgroundColor: theme => theme.palette.grey[300] }}
        >

            <Grid size={3}>

                <Paper sx={{ p: 1 }}>
                    {!changed ? <>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                            marginBottom={1}
                        >
                            <Grid>
                                {
                                    errors['/'] && errors['/'].map((err, index) => (
                                        <FormHelperText key={index} error>
                                            {err.message}
                                        </FormHelperText>
                                    ))
                                }
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                        >

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'old password'}
                                    fullWidth
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                                {
                                    renderErrors(errors, 'userKey')
                                }
                            </Grid>

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'new password'}
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    inputProps={{
                                        type: 'password'
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            change();
                                        }
                                    }}
                                />
                                {
                                    renderErrors(errors, 'password')
                                }
                            </Grid>

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'confirm password'}
                                    fullWidth
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    inputProps={{
                                        type: 'password'
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            change();
                                        }
                                    }}
                                />
                                {
                                    renderErrors(errors, 'confirmPassword')
                                }
                            </Grid>

                            <Grid>
                                <Grid
                                    container
                                    direction='row'
                                    alignItems='center'
                                    justifyContent='space-around'
                                >
                                    <Grid>
                                        <Button variant='outlined' size="small" onClick={cancel}>{'Cancel'}</Button>
                                    </Grid>
                                    <Grid>
                                        <Button variant='contained' size="small" onClick={change}>{'Submit'}</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </> : renderConfirmMessage()
                    }
                </Paper>
            </Grid>
        </Grid>
    </>)
}

export default ChangePassword;
